import { useSections } from '../../context/site-content.context';
import { createElementId } from '../../helpers/content.helper';
import { ColumnVariant } from '../../models/component.model';
import { ImageContentDisplay } from '../images/ImageContentDisplay';
import { ContentHtml } from '../sections/ContentHtml';
import { LinkContentDisplay } from '../sections/LinkContentDisplay';

interface Props {
    item: ColumnVariant;
    before?: React.ReactNode;
    contentClassName?: string;
}

export const ColumnVariantDisplay = ({
    item,
    before,
    contentClassName,
}: Props): React.ReactElement<any, any> | null => {
    const sections = useSections(item.id);

    return (
        <div className={`content-background`}>
            <div
                className={`py-5 px-sm-5 px-4 column-variant-display content content-width ${
                    contentClassName || ''
                }`}
            >
                {before}
                <div className="row">
                    {sections.map(section => {
                        const id = createElementId(section.id);

                        return (
                            <div key={id} className="col-md">
                                <div id={id}>
                                    {section.image && (
                                        <div className="mb-2">
                                            <ImageContentDisplay image={section.image} />
                                        </div>
                                    )}
                                    {section.header && (
                                        <h2 className="display-6 mb-4 content-header">
                                            {section.header}
                                        </h2>
                                    )}
                                    {section.body && (
                                        <ContentHtml
                                            source={section.body}
                                            className={
                                                item.options?.textSize === 'md' ? '' : 'large'
                                            }
                                        />
                                    )}
                                    {section.link && (
                                        <div>
                                            <LinkContentDisplay link={section.link} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
